import { Navigate } from 'react-router';
import { agentPoolsTabPath } from '@/components/agent-pools-admin/agent-pools-tabs';

export default function MediaAgentAdminPage() {
  return <Navigate to={agentPoolsTabPath('media-agent')} replace />;
}
